import Vue from 'vue'
import axios from './vue-axios/axios'

export function occupationListFromEntity(entity_id){
  return Vue.axios.get('/v1/entities/' + entity_id + '/occupations');
}

export function createNewOccupation(occupation) {
  var params = {
    occupation: occupation
  }
  return Vue.axios.post('/v1/occupations', params)
}

export function updateOccupation(occupation) {
  var params = {
    occupation: occupation
  }
  return Vue.axios.put('/v1/occupations/' + occupation.id, params)
}

export function deleteOccupation(occupation) {
  return Vue.axios.delete('/v1/occupations/' + occupation.id)
}

export function getDestroyOccupationPermission(occupationId){
  return Vue.axios.get('/v1/occupations/' + occupationId + '/destroy_permission')
}

export function changeOccupationActiveStatus(occupation_id, params) {
  return Vue.axios.put('/v1/occupations/' + occupation_id + '/change_active_status', params)
}

export function getDeactivateOccupationPermission(occupation_id, params){
  return Vue.axios.get('/v1/occupations/' + occupation_id + '/deactivate_permission', { params })
}



// WEBPACK FOOTER //
// ./src/backend/occupations.js